import { useEffect, useState } from 'react';
import { IconChevronDown } from '@tabler/icons-react';
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
  cn,
} from '@/app/shared/ui';

export interface LangDropdownProps {
  items: { label: string; value: string }[];
  onChange?: (value: string) => void;
  defaultSelected?: string;
  /** When true, renders with a translucent on-dark surface (login background). */
  isWhite?: boolean;
}

export const LangDropdown = ({
  items,
  onChange,
  defaultSelected,
  isWhite = false,
}: LangDropdownProps) => {
  const [selected, setSelected] = useState(defaultSelected || items[0].value);

  useEffect(() => {
    if (defaultSelected) setSelected(defaultSelected);
  }, [defaultSelected]);

  const handleSelect = (value: string) => {
    setSelected(value);
    onChange?.(value);
  };

  const current = items.find((i) => i.value === selected) ?? items[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant={isWhite ? 'outline' : 'outline'}
          size="md"
          rightIcon={<IconChevronDown size={14} />}
          className={cn(
            'font-bold tracking-wide',
            isWhite &&
              'border-white/40 bg-white/10 text-white hover:bg-white/20 hover:text-white',
          )}
        >
          {current.label.toUpperCase()}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[6rem]">
        <DropdownMenuRadioGroup value={selected} onValueChange={handleSelect}>
          {items.map((item) => (
            <DropdownMenuRadioItem key={item.value} value={item.value}>
              {item.label}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
